import { collection, onSnapshot } from "firebase/firestore";
import { Image } from "./image";
import React, { useEffect, useState } from "react";
import { db } from "../firebase/firebase";

export const Gallery = (props) => {
  const [themes, setThemes] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const unsubscribe = onSnapshot(collection(db, "themes"), (snapshot) => {
      const themeData = snapshot?.docs?.map((doc) => ({
        key: doc.id, // ใช้เป็น key ของตาราง
        ...doc.data(),
      }));
      setThemes(themeData);
      setLoading(false);
    });

    return () => unsubscribe(); // ยกเลิกการติดตามเมื่อ component ถูก unmount
  }, []);

  console.log("themes", themes);

  return (
    <div id="gallery" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Gallery</h2>
          <p>รวมภาพบรรยากาศ และกิจกรรมสำคัญในการจัดงาน </p>
        </div>
        <div className="row">
          <div className="portfolio-items">
            {themes
              ? themes.map((d, i) => (
                  <div
                    key={`${d.theme}-${i + 1}`}
                    className="col-sm-6 col-md-4 col-lg-4"
                  >
                    <Image
                      title={d.theme}
                      largeImage={
                        process.env.REACT_APP_URL_IMAGE + d.imageTitle
                      }
                      smallImage={
                        process.env.REACT_APP_URL_IMAGE + d.imageTitle
                      }
                      item={d}
                    />
                  </div>
                ))
              : "Loading..."}
          </div>
        </div>
      </div>
    </div>
  );
};
